import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  background: ${(p) => p.theme.palette.primary[50]};
  width: 100%;
  border-radius: ${(p) => p.theme.spacing(2)};
  padding: ${(p) => p.theme.spacing(2)};
`;
